function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
import { memo } from 'react';
const Close = props => /*#__PURE__*/React.createElement(Svg, _extends({
  width: 22,
  height: 22
}, props), /*#__PURE__*/React.createElement(Path, {
  d: "m1 1 20 20M1 21 21 1",
  stroke: "#222A34",
  strokeWidth: 1.5,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round"
}));
const CloseIcon = /*#__PURE__*/memo(Close);
export default CloseIcon;
//# sourceMappingURL=index.js.map